import { useNode } from "@craftjs/core";
import React from "react";
import { isUpdatedFromDefault } from "../../utils";

import {
  TextActiveIcon,
  PencilActiveIcon,
  PaintIcon,
  SettingsIcon,
  AlignContentEndIcon,
  AlignCenterIcon,
  AlignContentAroundIcon,
  AlignContentBetweenIcon,
  AlignContentCenterIcon,
  AlignContentSpaceEvenIcon,
  AlignContentTopIcon,
  AlignEndIcon,
  AlignStartIcon,
  DisplayBlockIcon,
  FlexColumnIcon,
  FlexIcon,
  FlexNoWrapIcon,
  FlexRowIcon,
  FlexWrapIcon,
} from "../../../assets/ui-icons";

import {
  ColorInput,
  MarginInput,
  PaddingInput,
  Panel,
  RangeInput,
  SelectRadioButtonInput,
  SpacerInput,
  Tabs,
} from "./../../ui-kit";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSContainerSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    width = "100%",
    height,
    maxWidth,
    maxHeight,
    blockGap = "1rem",
    padding = {
      top: "20px",
      bottom: "20px",
      left: "20px",
      right: "20px",
    },
    margin,
    textColor,
    linkColor,
    minWidth,
    minHeight,
    backgroundColor,
    display,
    wrap,
    justifyContent,
    direction = "column",
    alignItems,
  } = props;

  const DISPLAY = [
    {
      label: "Block",
      value: "block",
      icon: <DisplayBlockIcon width={"200px"} height={"200px"} />,
      tooltip: "Block",
    },
    {
      label: "Flex",
      value: "flex",
      icon: <FlexIcon />,
      tooltip: "Flex",
    },
  ];

  const DIRECTION = [
    {
      label: "Column",
      value: "column",
      tooltip: "Column",
      icon: <FlexColumnIcon />,
    },
    {
      label: "Row",
      value: "row",
      tooltip: "Row",
      icon: <FlexRowIcon />,
    },
  ];

  const WRAP = [
    {
      label: "Wrap",
      value: "wrap",
      tooltip: "Wrap",
      icon: <FlexWrapIcon />,
    },
    {
      label: "Nowrap",
      value: "nowrap",
      tooltip: "Nowrap",
      icon: <FlexNoWrapIcon />,
    },
  ];

  const JUSTIFYCONTENT = [
    {
      label: "Start",
      value: "start",
      tooltip: "Start",
      icon: <AlignContentTopIcon />,
    },
    {
      label: "Center",
      value: "center",
      tooltip: "Center",
      icon: <AlignContentCenterIcon />,
    },
    {
      label: "End",
      value: "end",
      tooltip: "End",
      icon: <AlignContentEndIcon />,
    },
    {
      label: "Space Between",
      value: "space-between",
      tooltip: "Space-between",
      icon: <AlignContentBetweenIcon />,
    },
    {
      label: "Space Around",
      value: "space-around",
      tooltip: "Space-around",
      icon: <AlignContentAroundIcon />,
    },
    {
      label: "Space Evenly",
      value: "space-evenly",
      tooltip: "Space Evenly",
      icon: <AlignContentSpaceEvenIcon />,
    },
  ];

  const ALIGNITEMS = [
    {
      label: "Start",
      value: "start",
      tooltip: "Start",
      icon: <AlignStartIcon />,
    },
    {
      label: "Center",
      value: "center",
      tooltip: "Center",
      icon: <AlignCenterIcon />,
    },
    {
      label: "End",
      value: "end",
      tooltip: "End",
      icon: <AlignEndIcon />,
    },
  ];
  const General = () => {
    return (
      <>
        <SpacerInput>
          <SelectRadioButtonInput
            resetValue={undefined}
            value={display}
            onChange={(val) => {
              setProp((props) => {
                props.display = val;
              });
            }}
            options={DISPLAY}
            label="Display"
          />
          {display === "flex" && (
            <>
              <SelectRadioButtonInput
                resetValue={"column"}
                value={direction}
                onChange={(val) => {
                  setProp((props) => {
                    props.direction = val;
                  });
                }}
                options={DIRECTION}
                label="Direction"
              />
              <SelectRadioButtonInput
                resetValue={undefined}
                value={wrap}
                onChange={(val) => {
                  setProp((props) => {
                    props.wrap = val;
                  });
                }}
                options={WRAP}
                label="Wrap"
              />
              {direction === "column" ? (
                <>
                  <SelectRadioButtonInput
                    resetValue={undefined}
                    value={alignItems}
                    onChange={(val) => {
                      setProp((props) => {
                        props.alignItems = val;
                      });
                    }}
                    options={ALIGNITEMS}
                    label="Align"
                  />
                  <SelectRadioButtonInput
                    layout="newline"
                    resetValue={undefined}
                    value={justifyContent}
                    onChange={(val) => {
                      setProp((props) => {
                        props.justifyContent = val;
                      });
                    }}
                    options={JUSTIFYCONTENT}
                    label="Vertical Align"
                  />
                </>
              ) : (
                <>
                  <SelectRadioButtonInput
                    rotateIcon={-90}
                    layout="newline"
                    resetValue={undefined}
                    value={justifyContent}
                    onChange={(val) => {
                      setProp((props) => {
                        props.justifyContent = val;
                      });
                    }}
                    options={JUSTIFYCONTENT}
                    label="Align"
                  />
                  <SelectRadioButtonInput
                    rotateIcon={90}
                    resetValue={undefined}
                    value={alignItems}
                    onChange={(val) => {
                      setProp((props) => {
                        props.alignItems = val;
                      });
                    }}
                    options={ALIGNITEMS}
                    label="Vertical Align"
                  />
                </>
              )}
            </>
          )}
          <RangeInput
            resetValue={"100"}
            // min={5}
            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            label="Width"
            value={width}
            onChange={(val) => {
              setProp((props) => {
                props.width = val + "%";
              });
            }}
          />
          <RangeInput
            // min={5}

            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            label="Height"
            value={height}
            onChange={(val) => {
              setProp((props) => {
                props.height = val + "%";
              });
            }}
          />
          <RangeInput
            // min={5}
            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            label="Min Width"
            value={minWidth}
            onChange={(val) => {
              setProp((props) => {
                props.minWidth = val + "%";
              });
            }}
          />
          <RangeInput
            // min={5}
            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            label="Min Height"
            value={minHeight}
            onChange={(val) => {
              setProp((props) => {
                props.minHeight = val + "%";
              });
            }}
          />
          <RangeInput
            // min={5}
            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            label="Max Width"
            value={maxWidth}
            onChange={(val) => {
              setProp((props) => {
                props.maxWidth = val + "%";
              });
            }}
          />
          <RangeInput
            // min={5}
            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            label="Max Height"
            value={maxHeight}
            onChange={(val) => {
              setProp((props) => {
                props.maxHeight = val + "%";
              });
            }}
          />

          <RangeInput
            resetValue={"1rem"}
            label="Gap"
            value={blockGap}
            min={INPUT_LIMITS["cms-gap"].min}
            max={INPUT_LIMITS["cms-gap"].max}
            onChange={(val) => {
              setProp((props) => {
                props.blockGap = val + "px";
              });
            }}
          />
        </SpacerInput>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              value={textColor}
              onChange={(val) => {
                setProp((props) => {
                  props.textColor = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
            />
            <ColorInput
              value={linkColor}
              onChange={(val) => {
                setProp((props) => {
                  props.linkColor = val;
                });
              }}
              label={"Link"}
            />
            <ColorInput
              value={backgroundColor}
              onChange={(val) => {
                setProp((props) => {
                  props.backgroundColor = val;
                });
              }}
              label={"Background"}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const Advance = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Dimensions"}>
          <SpacerInput>
            <PaddingInput
              value={padding}
              onChange={(val) => {
                setProp((props) => {
                  props.padding = val;
                });
              }}
            />
            <MarginInput
              value={margin}
              onChange={(val) => {
                setProp((props) => {
                  props.margin = val;
                });
              }}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];
  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar title={"Container"} icon={<TextActiveIcon />} />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
